import { type Program, createProgram } from 'models';
import { useQuery } from 'query';
import { getProgram } from '../services';
import { getProgramQueryKey } from './keys';

export const useProgramQuery = ({ programId }: { programId?: string }) =>
  useQuery<Program>({
    enabled: Boolean(programId),
    async queryFn() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- This will run only if `programId` is defined
      const { data } = await getProgram({ routeParams: { id: programId! } });
      return createProgram(data);
    },
    queryKey: getProgramQueryKey({ programId }),
    throwOnError: true,
  });
